//regex is used to support paste action on input field.
export const numbersOnly = (key) => {
	const validKeys = '0123456789,-.()';
	const regex = /^-?(\d*\.|,)?\d+$/;
	return (validKeys.indexOf(key) >= 0 || key.match(regex) || key === "Enter");
}

export const positiveNumbersOnly = (key) => {
	const validKeys = '0123456789,.';
	const regex = /^(\d*\.|,)?\d+$/;
	return (validKeys.indexOf(key) >= 0 || key.match(regex) || key === "Enter");
}

export const positiveIntegersOnly = (key) => {
	const validKeys = '0123456789';
	const regex = /^[0-9\b]+$/;
	return (validKeys.indexOf(key) >= 0 || key.match(regex) || key === "Enter");
}

export const integersOnly = (key) => {
	const validKeys = '0123456789-';
	const regex = /^-?[0-9\b]+$/;
	return (validKeys.indexOf(key) >= 0 || key.match(regex) || key === "Enter");
}


// WEBPACK FOOTER //
// ./src/fw/forms/helpers/Filters.js